export enum OnboardingFlowStatus {
  ACTIVE = "active",
  COMPLETED = "completed",
  DISMISSED = "dismissed",
}

export type OnboardingFlowPatch = {
  status: OnboardingFlowStatus;
  completedAt?: string;
  dismissedAt?: string;
  dismissalReason?: string;
};

export const ONBOARDING_FLOW_METADATA_KEY = "onboardingFlow";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function getOnboardingFlow(metadata: GraphQLJSON | null | undefined) {
  const onboardingFlow = metadata?.[ONBOARDING_FLOW_METADATA_KEY];

  return isRecord(onboardingFlow) ? onboardingFlow : undefined;
}

export function getOnboardingFlowStatus(
  metadata: GraphQLJSON | null | undefined,
) {
  if (!isRecord(metadata)) return;

  const onboardingFlow = getOnboardingFlow(metadata);
  if (!onboardingFlow || onboardingFlow.status === undefined) {
    return OnboardingFlowStatus.ACTIVE;
  }

  const { status } = onboardingFlow;
  if (
    status === OnboardingFlowStatus.ACTIVE ||
    status === OnboardingFlowStatus.COMPLETED ||
    status === OnboardingFlowStatus.DISMISSED
  ) {
    return status;
  }
}
